export const clearHistoryStates = () => {
  window.history.replaceState({}, '');
};
